goog.provide("shadow.js.shim.module$src$svg$location$map_marker_outlined_svg$default");
shadow.js.shim.module$src$svg$location$map_marker_outlined_svg$default = shadow.js.shim.module$src$svg$location$map_marker_outlined_svg.default;
